import { Phone, FileText } from "lucide-react";
import { PHONE_HREF } from "@/lib/site-data";

export default function MobileBar() {
  return (
    <div
      data-testid="mobile-bottom-bar"
      className="fixed bottom-0 inset-x-0 z-[60] md:hidden grid grid-cols-2 border-t border-white/10 bg-black/90 backdrop-blur-xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={PHONE_HREF}
        data-testid="mobile-bar-call-btn"
        className="flex items-center justify-center gap-2 bg-[#0066FF] py-4 text-sm font-bold tracking-widest text-white"
      >
        <Phone size={17} /> CALL NOW
      </a>
      <a
        href="#estimate"
        data-testid="mobile-bar-estimate-btn"
        className="flex items-center justify-center gap-2 bg-[#00E5FF] py-4 text-sm font-bold tracking-widest text-black"
      >
        <FileText size={17} /> FREE ESTIMATE
      </a>
    </div>
  );
}
